/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
      path: '/login',
      name: 'Login',
      view: 'Login'
    },
    {
      path: '/forgot-password',
      name: 'Forgot password',
      view: 'Forgot'
    },
    {
      path: '/no-permission',
      name: 'No Permission',
      view: 'NoPermission'
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      view: 'Dashboard'
    },
    {
      path: '/transactions',
      name: 'Transactions',
      view: 'Transactions'
    },
    {
      path: '/accounts',
      name: 'Accounts',
      view: 'admin/Accounts'
    },
    {
      path: '/purchase',
      name: 'Purchases',
      view: 'admin/Purchase'
    },
    {
      path: '/deliveries',
      name: 'Deliveries',
      view: 'admin/Deliveries'
    },
    {
      path: '/sales',
      name: 'Sales',
      view: 'admin/Sales'
    },
    {
      path: '/keeps',
      name: 'Keeps & Borrowed',
      view: 'admin/BorrowedKeeps'
    },
    {
      path: '/products',
      name: 'Products',
      view: 'admin/Products'
    },
    {
      path: '/delivery-reports',
      name: 'Checker Reports',
      view: 'admin/DeliveryReports'
    },
    {
      path: '/purchase/view/:id',
      name: 'View Purchase',
      view: 'admin/PurchaseView'
    },
    {
      path: '/sales-view/:id',
      name: 'View Sales',
      view: 'admin/SalesView'
    },
    {
      path: '/delivery-view/:id',
      name: 'View Delivery',
      view: 'admin/DeliveryView'
    },
    {
      path: '/customers',
      name: 'Customers',
      view: 'admin/Customers'
    },
    {
      path: '/trucks',
      name: 'Trucks',
      view: 'admin/Trucks'
    },
    {
      path: '/settings',
      name: 'Settings',
      view: 'admin/Settings'
    },
    {
      path: '/inventory-reports',
      name: 'DSIR',
      view: 'reports/Inventory'
    },
    {
      path: '/sales-reports',
      name: 'Sales Reports',
      view: 'reports/SalesReports'
    },
    {
      path: '/merchandise-reports',
      name: 'Merchandise',
      view: 'reports/Merchandise'
    },
    {
      path: '/outlet-monitoring',
      name: 'Outlet Monitoring',
      view: 'reports/OutletMonitoring'
    },
    {
      path: '/stock-movement',
      name: 'Stock Movement',
      view: 'reports/StockMovement'
    },
    {
      path: '/checker/:dr',
      name: 'Checker',
      view: 'apps/Checker'
    },
    {
      path: '/receivables',
      name: 'Acct. Receivables',
      view: 'accounting/Receivables'
    },
    {
      path: '/payments',
      name: 'Billing & Payments',
      view: 'accounting/Payments'
    },
    {
      path: '/invoices',
      name: 'Invoices',
      view: 'accounting/Invoices'
    },
  ]
  